import axios from 'axios';

export default class TagsService
{
    public static async getAutcomplete(tagName: string, locale: string)
    {
        return (await axios.get<string[]>('admin/cms/tags/autocomplete', {
            params: { tagName, locale }
        })).data;
    }

    public static async getList(filter: FilterModel, pager: Pager)
    {
        return (await axios.get<Pagination<ListItemModel>>('admin/cms/tags', {
            params: { ...filter, ...pager.data() }
        })).data;
    }

    public static async create(model: FormModel)
    {
        return (await axios.post<Resource<FormModel>>(`admin/cms/tags`, model)).data;
    }

    public static async update(id: number, model: FormModel)
    {
        return (await axios.put<Resource<FormModel>>(`admin/cms/tags/${id}`, model)).data;
    }

    public static async remove(id: number)
    {
        return (await axios.delete(`admin/cms/tags/${id}`)).data as Statement;
    }
}

export interface ListItemModel
{
    id: number;
    tagName: string;
}

export interface FilterModel
{
    tagName: string;
    locale: string;
}

export interface FormModel
{
    id: number;
    tagName: string;
    locale: string;
}
